<template>
  <AppLayout>
    <template #header>
      <PageHeadingWithActionsAndBreadcrumbs
        :title="getLegDisplayName(props.leg)"
        :breadcrumbs="getFirstBreadcrumbLevel()"
      />
    </template>

    <div class="space-y-6">
      <AirportCard :airport="props.leg.departure_airport" />
      <AirportCard :airport="props.leg.arrival_airport" />
    </div>
  </AppLayout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import { getLegDisplayName } from '../Common'
import PageHeadingWithActionsAndBreadcrumbs from '@/Common/Headings/PageHeadings/PageHeadingWithActionsAndBreadcrumbs.vue'

import AirportCard from './AirportCard.vue'

const props = defineProps({
  trip: Object,
  leg: Object,
})

function getFirstBreadcrumbLevel() {
  return [
    {
      title: 'Trip',
      href: route('trips.show', props.trip),
    },
  ]
}
</script>
